import { Component } from '@angular/core';

@Component({
  selector: 'vrc-sidebar-footer',
  template: `
    <footer class="sidebar-footer">
    <a class="sidebar_copyright" target="_blank" href="https://www.vrsoft.com.br/">
      <img class="sidebar_copyright__logo_vr logo-vr-light" alt="VR SOFTWARE">
      <img class="sidebar_copyright__tipo_vr tipo-vr-light" alt="Copyright">
    </a>
    <div class="sidebar_toggle">
      <button type="button" class="btn--reset sidebar_toggle__theme">
        <i role="button" data-toggle="set-theme" class="vr vr-lightbulb_light theme_icon"></i>
      </button>
      <button type="button" class="btn--reset sidebar_toggle__fixed">
        <i role="button" class="vr vr-thumbtack fixed-menu"></i>
      </button>
      <button type="button" class="btn--reset sidebar_toggle__arrow">
        <i role="button" data-toggle="push-menu" class="vr vr-double_arrow_right sidebar-toggle"></i>
      </button>
    </div>
  </footer>
  `
})
export class VrcSidebarFooterComponent { }




